import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { YSButton } from "../../uikit/YSButton";
import { useNavigate } from "react-router";
import DRxLogo from "../../images/icons/DRxLogo.svg";
import { AcceptEndUserAgreement } from "../../Apis/AuthApiServices";
import YSSnackBar from "../../uikit/YSSnackBar";
import { hasClientAuthSession } from "../../utils/authCookie";
import { getRxExperienceEntryPath } from "../../utils/AIPrescription/rxExperiencePreference";

export default function TermsAndConditions() {
  const [tnc, setTnc] = useState(false);
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const navigate = useNavigate();
  const acceptTermsAndConditions = async () => {
    try {
      const result = await AcceptEndUserAgreement();
      if (result?.data?.digitalRxStatusCode === 200) {
        localStorage.setItem("termsAgree", "false");
        if (
          sessionStorage.getItem("patientId") != "null" &&
          localStorage.getItem("quickNav") == "null"
        ) {
          navigate("/dashboard");
        } else if (localStorage.getItem("quickNav") == "true") {
          navigate(getRxExperienceEntryPath(), { state: "integratedLogin" });
        } else {
          navigate("/patientsearch");
        }
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {}
  };

  const agree = localStorage.getItem("termsAgree") ?? undefined;
  useEffect(() => {
    if (hasClientAuthSession() && agree == "false") {
      navigate("/patientsearch", { replace: true });
    }
  }, [agree, navigate]);
  return (
    <>
      <Grid
        container
        xs={12}
        spacing={1}
        alignItems="top"
        justifyContent="center"
        padding={4}
      >
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={12} textAlign="center">
            <Box className="logoIcon">
              <img src={DRxLogo} alt={"logo"} loading="lazy" />
            </Box>{" "}
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography
              component={"h3"}
              fontWeight={700}
              textAlign={"center"}
              color="primary"
            >
              H2H Digital RxTM - END USER AGREEMENT
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography component={"p"} textAlign={"left"} variant="body2">
              H2H Solutions, Inc. ("H2H") provides participating subscribers
              with the ability to access an online information management system
              named <i>H2H Digital RxTM</i> (the "System"). All duly authorized
              subscribers ("Subscribing Organizations") must first execute a
              binding Subscription Agreement ("Subscription") with either (1)
              H2H or (2) a third party service provider that has executed a
              binding Subscription with H2H. All duly authorized end users ("End
              Users") acting on behalf of a Subscribing Organization must first
              affirm their consent to be bound by the terms and conditions of
              this End User Agreement ("Agreement"), the terms of which may be
              changed from time to time at the sole discretion of H2H.{" "}
              <Typography
                color="primary"
                fontWeight={600}
                variant="body2"
                display="inline"
              >
                IF YOU DO NOT AGREE TO BE BOUND BY THE TERMS OF THIS AGREEMENT,
                DO NOT USE THE SYSTEM.
              </Typography>
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography component={"p"} textAlign={"left"} variant="body2">
              If a provision in this Agreement affirmatively conflicts with a
              provision in the applicable Subscription, the terms and conditions
              of the Subscription supersedes the affirmatively conflicting
              provision in this Agreement. H2H reserves the right to add and
              delete provisions to this Agreement, and to revise, change, and
              modify this Agreement at anytime without notice to you.
            </Typography>
          </Grid>
          <Grid
            container
            margin={2}
            rowSpacing={1}
            columnSpacing={2}
            overflow={"auto"}
            maxHeight={500}
            bgcolor={"whitesmoke"}
          >
            <Grid item xs={12} md={12}>
              <Typography
                component={"h5"}
                fontWeight={700}
                textAlign={"center"}
                color="primary"
              >
                Terms and Conditions
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <ol>
                <li>
                  {" "}
                  <b>Conditions for Access.</b> You are authorized to utilize
                  the System on behalf of your Subscribing Organization for the
                  legitimate internal business purposes of your Subscribing
                  Organization. All other uses of the System are expressly
                  excluded and prohibited. Your ability to access the System is
                  contingent upon certain conditions set forth below:
                  <ul>
                    <li>
                      You shall comply at all times with ALL the terms and
                      conditions of the Subscription
                    </li>
                    <li>
                      You shall comply at all times with ALL the terms and
                      conditions of this Agreement
                    </li>
                    <li>
                      You shall comply at all times with ALL applicable federal,
                      state, and local laws and regulations including but not
                      limited to the Health Insurance Portability and
                      Accountability Act ("HIPAA") and related regulations
                    </li>
                    <li>
                      A current and active Subscription (i.e. not expired or
                      terminated) being held by your Subscribing Organization
                    </li>
                  </ul>
                </li>
                <li>
                  <b>Restrictions on Use.</b> Your ability to access the System
                  is contingent upon compliance with ALL of the following
                  restrictions:
                  <ul>
                    <li>
                      Your use of the System is limited to internal business use
                      on behalf of your Subscribing Organization and you shall
                      NOT access the System for any other purpose
                    </li>
                    <li>
                      You are NOT authorized to use the System or its content
                      for the benefit of any third parties
                    </li>
                    <li>
                      {" "}
                      You shall NOT use System to attempt to access RxHub
                      services except,in connection with and in conjunction with
                      the treatment of a specific patient in a scheduled or
                      walk-in outpatient visit or another specific treatment
                      event
                    </li>
                    <li>
                      You shall NOT use System to access or attempt to access
                      RxHub services for an inpatient or other acute service or
                      for any institutional service
                    </li>
                    <li>
                      You may NOT use any content in the System in the operation
                      of a service bureau, to provide time sharing services, or
                      in any other similar third party arrangement
                    </li>
                    <li>
                      You may NOT decompile, dissemble, or otherwise reverse
                      engineer any aspect of the System
                    </li>
                    <li>
                      You may NOT reproduce, publicly display, distribute or
                      create derivative works of the System, including but not
                      limited to Third Party Content (see Section 3) made
                      accessible through the System
                    </li>
                    <li>
                      Your may NOT create any derivative works of any content in
                      the System unless you or your organization originally
                      provided that content to the System in the first place
                    </li>
                    <li>
                      You may NOT provide third parties with access to the
                      System or its content except through the normal and
                      authorized functions of the System itself
                    </li>
                    <li>You may NOT upload any disabling or injurious code</li>
                    <li>
                      Your rights pursuant to this Agreement are
                      non-transferable and non-exclusive, and any attempt to
                      transfer any right to access the Agreement is immediately
                      null and void
                    </li>
                    <li>
                      You shall NOT disclose to any third party, any
                      confidential information pertaining to the System,
                      including but not limited to Third Party Content
                    </li>
                    <li>
                      You SHALL obtain all necessary consents and authorizations
                      necessary to allow the transmission of all data elements
                      by the System (including but not limited to individually
                      identifiable health information) whether or not you intend
                      to utilize those data elements in your use of the System
                    </li>
                  </ul>
                </li>
                <li>
                  {" "}
                  <b>Third Party Content.</b>
                  The System includes content that is licensed to H2H by third
                  parties ("Third Party Content") and subject to certain
                  limitations and restrictions set by those third parties. Your
                  full use of the System is subject to continued availability of
                  the Third Party Content utilized by the System. Current Third
                  Party Content that can be utilized through use of the System
                  includes:
                  <ul>
                    <li>
                      system for facilitating electronic pharmaceutical
                      prescribing and accessing benefit information
                    </li>
                    <li>
                      messenger service for electronic prescription messages
                    </li>
                    <li>databases of pharmaceutical information</li>
                    <li>
                      other information and/or functionality incorporated into
                      the System at the sole discretion of H2H
                    </li>
                  </ul>
                  The terms and conditions for use of third party content is
                  subject to change by the applicable provider of Third Party
                  Content and are fully outside the control of H2H. You agree to
                  provide H2H and Third Party Content providers with the right
                  to access, inspect, and audit your use of System.
                </li>
                <li>
                  <b>Responsibility for your access information.</b> You and
                  your Subscribing Organization are responsible for maintaining
                  the confidentiality of your login ID and password and for
                  restricting access to your computer. You hereby accept full
                  responsibility for ALL activities that occur under your login
                  ID and password.
                </li>
                <li>
                  <b>Termination.</b> H2H reserves the right to cut-off your
                  access to the System at any time. If your access to the System
                  is permanently terminated, H2H will provide timely notice to
                  your Subscribing Organization.
                </li>
                <li>
                  <b>Disclaimer.</b> EXCEPT AS SET FORTH IN THE APPLICABLE
                  SUBSCRIPTION BETWEEN H2H AND YOUR SUBSCRIBING ORGANIZATION,
                  YOUR ACCESS TO THE SYSTEM IS PROVIDED ON AN "AS IS" BASIS.NO
                  EXPRESS OR IMPLIED WARRANTIES ARE PROVIDED TO YOU EXCEPT FOR
                  THOSE WARRANTIES EXPRESSLY AND SPECIFICALLY SET FORTH IN THE
                  APPLICABLE SUBSCRIPTION. ALL OTHER EXPRESS AND IMPLIED
                  WARRANTIES ARE SPECIFICALLY DISCLAIMED, INCLUDING BUT NOT
                  LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
                  NON-INFRINGEMENT, AND FITNESS FOR A PARTICULAR PURPOSE. H2H
                  MAKES NO WARRANTY THAT USE OF THE SYSTEM WILL BE
                  UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE.
                </li>
                <li>
                  <b>Liability Limitations/Damages Exclusions.</b> Except as
                  expressly specified in the provisions of the applicable
                  Subscription, the System is provided to you on an AS IS basis.
                  Under no circumstances shall H2H have any liability to you
                  resulting from your use of the System. Under no circumstances
                  shall H2H have any liability to you in excess to the monies
                  paid by you personally to H2H in exchange for your access the
                  System. YOU HEREBY WAIVE ANY AND ALL CLAIMS AGAINST H2H FOR
                  CONSEQUENTIAL DAMAGES (INCLUDING LOST PROFITS) AND PUNITIVE
                  DAMAGES PURSUANT TO THIS AGREEMENT. The provisions of Section
                  6 and 7 apply to all actions in contract, warranty, tort, and
                  all other legal theories.
                </li>
                <li>
                  <b>Intellectual Property.</b> Neither you nor your Subscribing
                  Organization obtains any rights to the System except for the
                  limited right to access the System as provided in this
                  Agreement and the applicable Subscription. Neither you nor
                  your Subscribing Organization obtains any intellectual
                  property rights embodied in the System through your use of the
                  System. Except for information that you or your Subscribing
                  Organization enter into the System, all information,
                  materials, functions and other content accessible through the
                  System are proprietary to H2H or its vendors. All expressive
                  content are either the copyrighted property H2H or the
                  copyrighted property of H2H's licensors. All trademarks,
                  service marks, trade names, and are proprietary to H2H and/or
                  our H2H's licensors. H2H does not grant you any express or
                  implied rights or licenses under any patents, trademarks,
                  copyrights, or other proprietary or intellectual property
                  right.
                </li>
                <li>
                  <b>Exclusive Jurisdiction/Choice of Law.</b> You agree that
                  any action at law or in equity arising out of or relating to
                  these terms of use shall be filed, and that venue properly
                  lies, only in state courts located in Oakland County,
                  Michigan, or in federal courts located in the Eastern District
                  of Michigan. You hereby consent and submit to the exclusive
                  personal jurisdiction of such courts for the purposes of
                  litigating any such action.
                </li>
              </ol>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography variant="body2" component={"span"}>
              <Checkbox
                name={"tnc"}
                onChange={(e) => setTnc(e.target.checked)}
                value={tnc}
              />
              I HAVE READ AND AGREED TO THE ABOVE TERMS AND CONDITIONS
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} textAlign={"center"}>
            <YSButton
              onClick={() => {
                acceptTermsAndConditions();
              }}
              className=""
              children={"Agree"}
              size={"large"}
              type="button"
              color="primary"
              variant="contained"
              disabled={tnc ? false : true}
            />{" "}
            <YSButton
              onClick={() => {
                navigate("/");
              }}
              className=""
              children={"Disagree"}
              size={"large"}
              type="button"
              color="primary"
              variant="contained"
            />{" "}
          </Grid>
        </Grid>
      </Grid>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
